export default "__VITE_ASSET__BX8WN_qq__"